// extracted by mini-css-extract-plugin
export default {"profile__title":"wQqE8U9xW1IK0TZ8BKbe","profile__img":"KYb15gonUT9EHQcOqjHg","profile__exit":"YB0rWpQxuQrIDZNWAvde"};